// Shown to email/password users until they verify their email (docs/tokens.md section 7).
import { useState } from "react";
import { authErrorMessage, type AuthUser } from "../auth/auth";
import { useServices } from "../components/context";

export function VerifyEmail({
  user,
  onVerified,
}: {
  user: AuthUser;
  onVerified: (u: AuthUser | null) => void;
}) {
  const { auth } = useServices();
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function attempt(fn: () => Promise<void>) {
    setBusy(true);
    setMsg(null);
    try {
      await fn();
    } catch (e) {
      setMsg(authErrorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="signin">
      <h1>Verify your email</h1>
      <div className="card">
        <p>
          We sent a verification link to <strong>{user.email}</strong>. Open the link, then click "I verified
          my email".
        </p>
        <div className="row">
          <button
            type="button"
            disabled={busy}
            onClick={() =>
              void attempt(async () => {
                const u = await auth.refresh();
                if (u?.emailVerified) onVerified(u);
                else setMsg("Your email is not verified yet.");
              })
            }
          >
            I verified my email
          </button>
          <button
            type="button"
            className="secondary"
            disabled={busy}
            onClick={() =>
              void attempt(async () => {
                await auth.sendVerification();
                setMsg("We sent a new link.");
              })
            }
          >
            Send the link again
          </button>
          <button type="button" className="link" onClick={() => void auth.signOut()}>
            Sign out
          </button>
        </div>
        {msg && <p className="banner">{msg}</p>}
      </div>
    </main>
  );
}
